// 导播台
import request from '@/utils/request'

/** 直播详情
 * @params  params.liveId 直播id
 * */
export const getLiveInfo = (params) => {
  return request({
    url: '/admin/cloud-caster/getLiveInfo',
    method: 'get',
    params
  })
}

/** 开启-关闭自动导播
 * @params  params.liveId 直播id
 * @params  params.autoCaster 是否开启自动导播, true-自动导播, false-手动导播
 */
export const openOrCloseAutoCaster = (params) => {
  return request({
    url: '/admin/cloud-caster/openOrCloseAutoCaster',
    method: 'post',
    params
  })
}

/** 流画面布局
 * @params  liveId
 * @params  布局参数
 */
export const layoutChange = (params) => {
  return request({
    // baseURL: 'https://tju-zhihuishu-livecourse-desktop.zhihuishu.com',
    // baseURL: 'https://zhs-zhihuishu-livecourse-desktop.zhihuishu.com',
    // url: '/livecourse-desktop/layout/change',
    url: '/admin/cloud-caster/layoutChange',
    method: 'post',
    data: params
  })
}

/** 修改昵称
 * @params  liveId
 * @params  userId
 * @params  nickname
 */
export const editNickName = (params) => {
  return request({
    // baseURL: 'https://tju-zhihuishu-livecourse-desktop.zhihuishu.com',
    // baseURL: 'https://zhs-zhihuishu-livecourse-desktop.zhihuishu.com',
    // url: '/livecourse-desktop/live/edit/nickname',
    url: '/admin/cloud-caster/editNickname',
    method: 'post',
    params
  })
}
/** 修改昵称
 * @params  liveId
 */
export const checkAuthority = (params) => {
  return request({
    url: '/admin/cloud-caster/checkAuthority',
    method: 'post',
    params
  })
}
/** 修改昵称
 * @params  classroomCode
 */
export const getDeviceByClassroomCode = (params) => {
  return request({
    url: '/admin/device/getByClassroomCode',
    method: 'post',
    params
  })
}
